<template>
  <section class="phero">
    <div class="glow-orb" :style="{ background: project.color, top: '-60px', right: '10%', width: '420px', height: '420px' }"></div>
    <div class="container phero-inner">
      <div class="phero-head" data-aos="fade-up">
        <div class="phero-icon" :style="{ background: project.color + '22', color: project.color, boxShadow: `0 0 40px ${project.color}33` }">
          <i :class="project.icon"></i>
        </div>
        <div class="phero-badges">
          <span v-for="b in project.badges" :key="b.value" class="badge">
            <span class="badge-label">{{ b.label }}</span>
            <span class="badge-value">{{ b.value }}</span>
          </span>
        </div>
      </div>

      <h1 class="phero-title" data-aos="fade-up" data-aos-delay="80">
        {{ project.name }}
      </h1>
      <p class="phero-tagline" data-aos="fade-up" data-aos-delay="140">
        <span class="phero-slash">//</span> {{ project.tagline }}
      </p>
      <p class="phero-desc" data-aos="fade-up" data-aos-delay="200">{{ project.description }}</p>

      <div class="phero-actions" data-aos="fade-up" data-aos-delay="260">
        <a :href="project.repo" target="_blank" rel="noopener" class="btn btn-primary">
          <i class="fa-brands fa-github"></i> 查看源码
        </a>
        <a :href="project.releases" target="_blank" rel="noopener" class="btn btn-ghost">
          <i class="fa-solid fa-tag"></i> 查看 Releases
        </a>
      </div>

      <div class="phero-stats" data-aos="fade-up" data-aos-delay="320">
        <div v-for="s in project.stats" :key="s.label" class="stat">
          <div class="stat-value">{{ s.value }}</div>
          <div class="stat-label">{{ s.label }}</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
defineProps({
  project: { type: Object, required: true }
})
</script>

<style scoped>
.phero {
  position: relative;
  padding: 80px 0 64px;
  overflow: hidden;
  background: linear-gradient(180deg, var(--bg-surface) 0%, var(--bg-base) 100%);
  border-bottom: 1px solid var(--border-soft);
}
.phero-inner { position: relative; z-index: 1; }
.phero-head {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 28px;
  flex-wrap: wrap;
}
.phero-icon {
  width: 64px; height: 64px;
  display: grid; place-items: center;
  border-radius: 16px;
  font-size: 1.7rem;
  border: 1px solid var(--border);
}
.phero-badges { display: flex; gap: 8px; flex-wrap: wrap; }
.badge {
  display: inline-flex;
  align-items: stretch;
  border-radius: 6px;
  overflow: hidden;
  font-family: var(--font-mono);
  font-size: 0.74rem;
  border: 1px solid var(--border);
}
.badge-label {
  padding: 4px 9px;
  background: #2d3239;
  color: #c9d1d9;
}
.badge-value {
  padding: 4px 9px;
  background: var(--accent);
  color: var(--bg-base);
  font-weight: 600;
}
.phero-title {
  font-family: var(--font-display);
  font-weight: 600;
  font-size: clamp(2.6rem, 6vw, 4.5rem);
  line-height: 1;
  letter-spacing: -0.03em;
  margin-bottom: 14px;
}
.phero-tagline {
  font-family: var(--font-mono);
  font-size: 1.05rem;
  color: var(--text-muted);
  margin-bottom: 22px;
}
.phero-slash { color: var(--accent); }
.phero-desc {
  max-width: 720px;
  font-size: 1.05rem;
  color: var(--text-muted);
  line-height: 1.8;
  margin-bottom: 32px;
}
.phero-actions { display: flex; gap: 14px; flex-wrap: wrap; margin-bottom: 48px; }
.phero-stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1px;
  background: var(--border-soft);
  border: 1px solid var(--border-soft);
  border-radius: 12px;
  overflow: hidden;
}
.stat {
  background: var(--bg-surface);
  padding: 24px 20px;
  text-align: center;
}
.stat-value {
  font-family: var(--font-mono);
  font-size: 1.7rem;
  font-weight: 600;
  color: var(--accent);
  margin-bottom: 4px;
}
.stat-label {
  font-size: 0.8rem;
  color: var(--text-muted);
}
@media (max-width: 768px) {
  .phero-stats { grid-template-columns: repeat(2, 1fr); }
}
</style>
